import React, { Component } from 'react';

import CircularProgress from 'material-ui/CircularProgress';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_es_ES from '@amcharts/amcharts4/lang/es_ES'


class Humedad extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  };

  componentDidMount() {
    setTimeout(() => {
      this.loadChart();
    }, 4000);
  }


  loadChart = () => {
    // Show the chart in the web
    this.setState({
      visible: true,
    });

    const chart = am4core.create("humedad", am4charts.XYChart);
    chart.zoomOutButton.disabled = true;
    chart.language.locale = am4lang_es_ES;


    chart.data = this.props.data;

    // Set input format for the dates
    chart.dateFormatter.inputDateFormat = "yyyy-MM-dd";

    // Create axes
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.groupData = true;
    dateAxis.renderer.grid.template.disabled = true;
    dateAxis.baseInterval = {
      "timeUnit": "day",
      "count": 1
    };
    dateAxis.renderer.minGridDistance = 60;
    dateAxis.dateFormats.setKey("month", "MMM");
    dateAxis.periodChangeDateFormats.setKey("month", "[bold]MMM");
    dateAxis.dateFormats.setKey("day", "MMM dd");
    dateAxis.periodChangeDateFormats.setKey("day", "[bold]MMM");
    dateAxis.dateFormats.setKey("hour", "HH:mm");
    dateAxis.periodChangeDateFormats.setKey("hour", "[bold]MMM dd[/]");
    dateAxis.dateFormats.setKey("minute", "HH:mm");
    dateAxis.periodChangeDateFormats.setKey("minute", "[bold]MMM dd[/]");
    dateAxis.keepSelection = true
    dateAxis.start = 0.6;

    const buttonContainer = chart.plotContainer.createChild(am4core.Container);
    buttonContainer.shouldClone = false;
    buttonContainer.align = "right";
    buttonContainer.valign = "top";
    buttonContainer.zIndex = 100;
    buttonContainer.marginTop = 0;
    buttonContainer.marginRight = 5;
    buttonContainer.layout = "horizontal";

    const zoomInButton = buttonContainer.createChild(am4core.Button);
    zoomInButton.label.text = "+";
    zoomInButton.events.on("hit", function (ev) {
      const diff = dateAxis.maxZoomed - dateAxis.minZoomed;
      const delta = diff * 0.2;
      dateAxis.zoomToDates(new Date(dateAxis.minZoomed + delta), new Date(dateAxis.maxZoomed - delta));
    });

    const zoomOutButton = buttonContainer.createChild(am4core.Button);
    zoomOutButton.label.text = "-";
    zoomOutButton.events.on("hit", function (ev) {
      dateAxis.zoomToIndexes(dateAxis.startIndex, dateAxis.endIndex);
    });
    
    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = "%";
    valueAxis.title.fontSize = 14;
    valueAxis.title.rotation = 0;
    valueAxis.extraMax = 0.2;
    valueAxis.min = 0;
    
    // Create series
    function createSeries(field, name, color) {
      const series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = field;  
      series.dataFields.dateX = "fecha";
      series.name = name;
      series.strokeWidth = 2;
      series.minBulletDistance = 10;
      series.stroke = am4core.color(color);
      series.fill = am4core.color(color);
      series.showOnInit = false;

      const bullet = series.bullets.push(new am4charts.CircleBullet());
      bullet.circle.stroke = am4core.color("#fff");
      bullet.circle.strokeWidth = 2;
      
      const bullethover = bullet.states.create("hover");
      bullethover.properties.scale = 2;
    }

    const serieActual = 'Año Actual';
    const serieAnterior = 'Año Anterior';

    createSeries("hum_prom_ant", serieAnterior, "#93C9D3");
    createSeries("hum_prom", serieActual, "#3BC4D0");

    // Make a panning cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.behavior = "zoomX";
    chart.cursor.xAxis = dateAxis;
    chart.cursor.lineY.disabled = true;
    valueAxis.cursorTooltipEnabled = false;

    // Create container to hold our hover labels
    const info = chart.chartContainer.createChild(am4core.Container);
    info.layout = "absolute";
    info.toBack();
    info.marginBottom = 20;
    info.paddingLeft = 10;
    info.x = 0;
    info.y = 0;
    info.zIndex = 100;
    info.background.fill = am4core.color("#847a7a");
    info.background.fillOpacity = 0;
    info.layout = "grid";

    // Create labels
    function createLabel(title, color) {
      const valueLabel = info.createChild(am4core.Label);
      valueLabel.id = title;
      valueLabel.text = "-";
      valueLabel.minWidth = 220;
      valueLabel.fontWeight = "bolder";
      valueLabel.fill = color;
    }

    chart.series.each((series) => {
      createLabel(series.name, series.stroke);
    });

    // Set up number format
    chart.numberFormatter.numberFormat = "###";

    // Show last item by default
    chart.events.on("ready", () => {
      chart.series.each((series) => {
        updateValues(series.dataItems.last, series.name);
      });
    });

    // Show overal close values when cursor is not shown
    chart.cursor.events.on("hidden", () => {
      chart.series.each((series) => {
        updateValues(series.dataItems.last, series.name);
      });
    });

    // Set up cursor's events to update the label
    chart.cursor.events.on("cursorpositionchanged", () => {
      chart.series.each((series) => {
        const dataItem = dateAxis.getSeriesDataItem(
          series,
          dateAxis.toAxisPosition(chart.cursor.xPosition),
          true
        );
        updateValues(dataItem, series.name);
      });
    });

    // Updates values
    function updateValues(dataItem, key) {
      chart.series.each(() => {
        if (!!dataItem) {
          const year = new Date().getFullYear();

          const label = chart.map.getKey(key);

          let text = `Prom.: ${!!dataItem["valueY"] ? `${chart.numberFormatter.format(dataItem["valueY"])}%` : '-'} `;

          let yeartext = '';

          if (key === serieAnterior) {
            yeartext += `(${year - 1}) `;
            text += ` Min.: ${!!dataItem.dataContext.hum_min_ant ? `${chart.numberFormatter.format(dataItem.dataContext.hum_min_ant)}%` : '-'} `;
            text += ` Max.: ${!!dataItem.dataContext.hum_max_ant ? `${chart.numberFormatter.format(dataItem.dataContext.hum_max_ant)}%` : '-'}`;
          } else {
            yeartext += `(${year}) `;
            text += ` Min.: ${!!dataItem.dataContext.hum_min ? `${chart.numberFormatter.format(dataItem.dataContext.hum_min)}%` : '-'} `;
            text += ` Max.: ${!!dataItem.dataContext.hum_max ? `${chart.numberFormatter.format(dataItem.dataContext.hum_max)}%` : '-'}`;
          }
          label.text  = yeartext + text;
        }
      });
    }
  }  

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }


  render() {
    if (this.state.visible) {
      return (
        <div id="humedad" style={{padding: '0'}} />
      );
    }
    return (
      // <div><h3>Cargando...</h3></div>
      <div style={{ position: 'relative', width: '100%', height: 'auto', padding: '10px', margin: 'auto auto' }}>
        <CircularProgress color={'#93c9d3'} size={200} thickness={10} value={70} />
      </div>
    );
  }
}

export default Humedad;



// WEBPACK FOOTER //
// ./src/charts/Humedad.js